import React from 'react';
import { NumberInput } from '@mantine/core';
import { useDebouncedFieldValue } from './useDebouncedFieldValue';

const MIN = 10;
const MAX = 2000;

/**
 * Largeur en px (Image, Vidéo…). Deux règles UX :
 * - frappe en état local, store Puck écrit à la pause (400 ms) / au blur —
 *   un dispatch par frappe re-rend le canvas (lag grandes pages) ;
 * - clamp à la validation seulement (clampBehavior="blur") :
 *   "strict" + min>0 refusait la frappe sous le min → impossible d'effacer.
 */
export function PxWidthInput({
  value, onChange, label, description = 'Vide = largeur automatique',
}) {
  const commit = (v) => {
    if (v === '' || v == null) {
      onChange(undefined);
      return;
    }
    onChange(Math.min(MAX, Math.max(MIN, Number(v))));
  };

  const {
    local, setLocal, change, focus, endFocus,
  } = useDebouncedFieldValue(value, commit);

  return (
    <NumberInput
      size="xs"
      label={label}
      description={description}
      value={local}
      onFocus={focus}
      onBlur={() => {
        endFocus();
        commit(local);
        // Le clamp ne se voit qu'à la validation (cf. en-tête) : on réaffiche
        // la valeur bornée après l'avoir écrite.
        if (local !== '' && local != null) {
          setLocal(Math.min(MAX, Math.max(MIN, Number(local))));
        }
      }}
      onChange={change}
      min={MIN}
      max={MAX}
      step={1}
      suffix=" px"
      clampBehavior="blur"
      allowDecimal={false}
    />
  );
}

export function puckPxWidthField(label, { description = 'Vide = largeur automatique' } = {}) {
  return {
    type: 'custom',
    label,
    render: ({ value, onChange }) => (
      <PxWidthInput value={value} onChange={onChange} label={label} description={description} />
    ),
  };
}
